export default {
    VERIFICATION_MUTATION(state, payload) {
        state.verification = payload
    }
}
